import React from 'react';
import { Button } from '@/components/ui/Button';
import { Card } from '@/components/ui/Card';
import { Plus } from 'lucide-react';

function CaptionTemplates({ onApplyTemplate }) {
  const templates = [
    {
      id: 1,
      name: 'Basic Template',
      content: '✨ Check out this video!\n\n#trending #viral'
    },
    {
      id: 2,
      name: 'Engagement Template',
      content: '🔥 Like if you agree!\nComment your thoughts below 👇\n\n#engagement #community'
    },
    {
      id: 3,
      name: 'Question Template',
      content: '❓ What do you think about this?\nLet me know in the comments!\n\n#question #discussion'
    }
  ];

  return (
    <div className="space-y-4">
      {templates.map(template => (
        <Card key={template.id} className="p-4 hover:shadow-md transition-shadow">
          <div className="flex justify-between items-start">
            <div>
              <h4 className="font-medium text-gray-900">{template.name}</h4>
              <p className="text-sm text-gray-500 mt-1 whitespace-pre-line">{template.content}</p>
            </div>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => onApplyTemplate(template)}
              className="flex items-center gap-2"
            >
              <Plus className="h-4 w-4" />
              Apply
            </Button>
          </div>
        </Card>
      ))}
    </div>
  );
}

export default CaptionTemplates; 